import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitSurveys = async ({
  visitId,
  stepId,
  surveyIds,
  disallowInvSurveySelection,
  isAllSurvey,
}) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (stepId) params.append("step_id", stepId);

  const payload = { survey_ids: surveyIds };
  if (disallowInvSurveySelection !== undefined) {
    payload.disallow_inv_survey_selection = disallowInvSurveySelection;
  }
  if (isAllSurvey !== undefined) payload.is_all_survey = isAllSurvey;

  const res = await axios.put(
    `${__API_URL__}/api/photos/visits/${visitId}/surveys/?${params.toString()}`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateVisitSurveysMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitSurveys,
    onSuccess: (_, variables) => {
      toast.success("Surveys updated");
      queryClient.invalidateQueries({ queryKey: ["visit_surveys", variables.visitId] });
      queryClient.invalidateQueries({ queryKey: ["visits"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update surveys");
    },
  });
};

export default useUpdateVisitSurveysMutation;
